import { LocationVarKey, SequenceEnabledStatus } from "@swivl-mono/types";

import { IF_ANY, IS_EQUAL, IS_NOT_EQUAL } from "../../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  Indent,
  InputRow,
  MultiLineRow,
  PageHeader,
  Section,
  SectionHeader,
  SwitchRow,
  TextAreaRow,
  TextRow
} from "../../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: LocationVarKey[] = [
  LocationVarKey.VoiceHasAccountBalanceIntegration,
  LocationVarKey.VoiceAccountBalanceHasAdditionalVerification,
  LocationVarKey.VoiceAccountBalanceAdditionalVerificationInfo,
  LocationVarKey.VoiceAccountBalanceFound,
  LocationVarKey.VoiceSendFoundAccountBalanceText,
  LocationVarKey.VoiceFoundAccountBalanceText,
  LocationVarKey.VoiceAccountBalanceNotFound,
  LocationVarKey.VoiceAccountBalanceMessage,
  LocationVarKey.VoiceSendAccountBalanceText,
  LocationVarKey.VoiceAccountBalanceTextMessage,
  LocationVarKey.VoiceForwardAccountBalance,
  LocationVarKey.VoiceAccountBalanceEscalateTo,
  LocationVarKey.VoiceAccountBalancePhoneNumber
];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page}>Account Balance</PageHeader>
      <br></br>
      <SwitchRow
        {...page}
        keyName={LocationVarKey.VoiceHasAccountBalanceIntegration}
        label="Use FMS to Lookup"
        hideIf={IS_NOT_EQUAL(LocationVarKey.VoiceHasAccountBalance, "1")}
      />

      <SectionHeader {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.VoiceHasAccountBalanceIntegration, "1")}>
        Account Balance Found
      </SectionHeader>
      <SwitchRow
        {...page}
        keyName={LocationVarKey.VoiceAccountBalanceHasAdditionalVerification}
        hideIf={IS_NOT_EQUAL(LocationVarKey.VoiceHasAccountBalanceIntegration, "1")}
        label="Verify Additional Information"
      />
      <InputRow
        {...page}
        hideIf={IF_ANY([
          IS_NOT_EQUAL(LocationVarKey.VoiceAccountBalanceHasAdditionalVerification, "1"),
          IS_NOT_EQUAL(LocationVarKey.VoiceHasAccountBalanceIntegration, "1")
        ])}
        keyName={LocationVarKey.VoiceAccountBalanceAdditionalVerificationInfo}
        label="Information"
      />
      <TextAreaRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.VoiceHasAccountBalanceIntegration, "1")}
        marginTop
        label=" Voice Message"
        keyName={LocationVarKey.VoiceAccountBalanceFound}
      />
      <SwitchRow
        {...page}
        keyName={LocationVarKey.VoiceSendFoundAccountBalanceText}
        hideIf={IS_NOT_EQUAL(LocationVarKey.VoiceHasAccountBalanceIntegration, "1")}
        label="Send SMS"
      />
      <TextAreaRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.VoiceSendFoundAccountBalanceText, "1")}
        marginTop
        label=" SMS Message"
        keyName={LocationVarKey.VoiceFoundAccountBalanceText}
      />
      <SectionHeader {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.VoiceHasAccountBalanceIntegration, "1")}>
        Account Balance Not Found
      </SectionHeader>
      <TextAreaRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.VoiceHasAccountBalanceIntegration, "1")}
        marginTop
        label=" Voice Message 1"
        keyName={LocationVarKey.VoiceAccountBalanceNotFound}
      />
      <TextAreaRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.VoiceHasAccountBalanceIntegration, "1")}
        marginTop
        label=" Voice Message 2"
        keyName={LocationVarKey.VoiceAccountBalanceMessage}
      />
      <TextAreaRow
        {...page}
        hideIf={IS_EQUAL(LocationVarKey.VoiceHasAccountBalanceIntegration, "1")}
        marginTop
        label=" Voice Message"
        keyName={LocationVarKey.VoiceAccountBalanceMessage}
      />
      <SwitchRow
        {...page}
        keyName={LocationVarKey.VoiceSendAccountBalanceText}
        hideIf={IS_EQUAL(LocationVarKey.VoiceHasAccountBalanceIntegration, "1")}
        label="Send SMS"
      />
      <SwitchRow
        {...page}
        keyName={LocationVarKey.VoiceSendAccountBalanceText}
        hideIf={IS_NOT_EQUAL(LocationVarKey.VoiceHasAccountBalanceIntegration, "1")}
        label="Send SMS"
      />
      <TextAreaRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.VoiceSendAccountBalanceText, "1")}
        marginTop
        label=" SMS Message"
        keyName={LocationVarKey.VoiceAccountBalanceTextMessage}
      />
      <SwitchRow
        {...page}
        keyName={LocationVarKey.VoiceForwardAccountBalance}
        hideIf={IS_NOT_EQUAL(LocationVarKey.VoiceHasAccountBalanceIntegration, "1")}
        label="Escalate"
      />
      <SwitchRow
        {...page}
        keyName={LocationVarKey.VoiceForwardAccountBalance}
        hideIf={IS_EQUAL(LocationVarKey.VoiceHasAccountBalanceIntegration, "1")}
        label="Escalate"
      />
      <DropdownRow
        {...page}
        hideIf={IS_EQUAL(LocationVarKey.VoiceForwardAccountBalance, "0")}
        label="Send escalations to"
        marginTop
        keyName={LocationVarKey.VoiceAccountBalanceEscalateTo}
        options={[
          { label: "swivl Conversations", value: "swivl" },
          { label: "External Phone Number", value: "phone" }
        ]}
      />
      <Section
        {...page}
        hideIf={IF_ANY([
          IS_NOT_EQUAL(LocationVarKey.VoiceForwardAccountBalance, "1"),
          IS_EQUAL(LocationVarKey.VoiceAccountBalanceEscalateTo, "swivl")
        ])}
      >
        <InputRow {...page} keyName={LocationVarKey.VoiceAccountBalancePhoneNumber} label="External Phone Number" />
        <div className="cortexDescription">
          This is the direct line defined{" "}
          <a
            href="/properties/page/cortex/voice/voice-settings"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#FF5B02", textDecoration: "underline" }}
          >
            here
          </a>
          . Only overwrite this if you have a different direct line for this use case!
        </div>
      </Section>
    </>
  );
}
